// Season 2 premiere — 3:00 PM Eastern. Edit this one value to move the countdown.
export const SEASON_2_PREMIERE_ISO = '2026-10-02T15:00:00-04:00'

export const season2Premiere = {
  id: 1,
  title: 'From Rooftops to War to Redemption & Identity',
  guest: '"Jim"',
  hometown: 'Washington',
  spotifyUrl:
    'https://open.spotify.com/episode/2OJFfVbAWWVtmGsDGdtaBt?si=ZyD_d45hSbedBlbekO8T4Q',
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/cddae6c7-02f5-4e67-bbfc-7967057c7358.jpg',
  hook: 'Homeless on the rooftops. Deployed to Iraq. Found by God in the middle of it all.',
  description: [
    '"Jim," whose name we have changed, began his story on a farm in Washington, where his grandparents raised him after his mother gave birth at 15. After a family tragedy, he found himself homeless, sometimes sleeping on rooftops and wondering where life would take him.',
    'A Greyhound bus brought him to Florida. He married Rochelle, joined the Army, and deployed to Iraq as a combat engineer. Surrounded by danger and far from home, "Jim" began reading the Bible. As he surrendered his life to God, he found a peace he hadn\'t known before.',
    'In this episode of the Three Doves Podcast, "Jim" shares what it was like to watch his first child\'s birth over Skype, how his faith grew after returning home, and why his work in law enforcement gave him a renewed sense of brotherhood. Through it all, he has learned to put God, his wife, and his children first.',
  ],
  journey: [
    {
      label: 'Rooftops',
      detail: 'Raised on a Washington farm, then homeless after a family tragedy.',
    },
    {
      label: 'War',
      detail: 'A Greyhound to Florida, the Army, and a deployment to Iraq.',
    },
    {
      label: 'Redemption',
      detail: 'A Bible in a war zone, and a peace he had never known.',
    },
    {
      label: 'Identity',
      detail: 'God first, then his wife and children — and a new brotherhood.',
    },
  ],
}
